module.exports = function() {
  return new Worker(__webpack_public_path__ + "e66149fe643b6a5f3758.worker.js");
};